import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";
import api from "../../api";

export default function EtfNetFlowChart() {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);

  const getEtfHistory = async () => {
    try {
      setLoader(true);
      const resp = await api.getEtfHistory();
      console.log("etf history");
      console.log(resp);
      if (resp?.data) {
        setData(resp.data || []);
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getEtfHistory();
  }, []);

  return (
    <div className="grayCard mCapChart mCard mb-3">
      <div className="title mb-3">Crypto ETFs Net Flow</div>

      <h4 className=" font-bold mb-4">
        {data.length ? (
          <>
            +$
            {data[data.length - 1].totalInflow.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            })}
          </>
        ) : (
          "Loading..."
        )}
      </h4>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={(d) =>
              new Date(d).toLocaleDateString("en-US", {
                day: "2-digit",
                month: "short",
              })
            }
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            tickFormatter={(v) =>
              v >= 1_000_000_000
                ? `$${v / 1_000_000_000}B`
                : `$${v / 1_000_000}M`
            }
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            formatter={(v) =>
              `$${v.toLocaleString(undefined, { maximumFractionDigits: 0 })}`
            }
            labelFormatter={(label) =>
              new Date(label).toLocaleDateString("en-US", {
                month: "short", // "Oct"
                day: "2-digit", // "14"
                year: "numeric", // "2025"
              })
            }
          />
          {/* ✅ Add Legend */}
          <Legend
            verticalAlign="bottom"
            height={26}
            iconType="circle"
            formatter={(value) => {
              if (value === "btcInflow") return "BTC INFLOW";
              if (value === "ethInflow") return "ETH INFLOW";
              return value;
            }}
          />

          {/* ETH (purple) */}
          <Bar dataKey="ethInflow" stackId="a" fill="#6f2cff" />
          {/* BTC (orange) */}
          <Bar dataKey="btcInflow" stackId="a" fill="#ffa500" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
